/**
 * @desc 获取BPM系统的用户角色的待办任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<
  defs.activiti.PageInfo<defs.activiti.BusinessTaskResponseDto>
>;
export function request(
  params: API.activiti.bpmApprovaTask.getPersonnelTaskListByBpmPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/personnelTask`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
